<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="journal-check" class="mr-2"></b-icon>Zakaslar hisoboti</h2>
        </div>
        <button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter">
          <label>Holat</label>
          <select v-model="statusFilter">
            <option value="">Barchasi</option><option value="new">Yangi</option>
            <option value="completed">Tugallangan</option><option value="canceled">Bekor</option>
          </select>
        </div>
      </div>

      <div class="rp-summary rp-summary-4">
        <div class="rp-card rp-c-1"><div class="rp-card-label">JAMI ZAKAS</div><div class="rp-card-value">{{ totals.count }}</div></div>
        <div class="rp-card rp-c-2">
          <div class="rp-card-label">YANGI</div>
          <div class="rp-card-value rp-blue">{{ countBy('new') }}</div>
        </div>
        <div class="rp-card rp-c-4">
          <div class="rp-card-label">TUGALLANGAN</div>
          <div class="rp-card-value rp-green">{{ countBy('completed') }}</div>
        </div>
        <div class="rp-card rp-c-3">
          <div class="rp-card-label">JAMI SUMMA</div>
          <div class="rp-card-value">{{ fmt(totals.total_summa) }}</div>
        </div>
      </div>

      <div class="rp-2col">
        <div class="rp-chart-wrap" v-if="byStatus.length > 0">
          <h3 class="rp-block-title"><b-icon icon="pie-chart-fill"></b-icon> Holatlar tuzilmasi</h3>
          <apexchart type="donut" height="260" :options="donutOptions" :series="donutSeries"></apexchart>
        </div>
        <div class="rp-section" v-if="byStatus.length > 0">
          <h3 class="rp-block-title"><b-icon icon="bar-chart-fill"></b-icon> Holat bo'yicha</h3>
          <table class="rp-table">
            <thead><tr><th>Holat</th><th class="t-center">Soni</th><th class="t-right">Jami summa</th></tr></thead>
            <tbody>
              <tr v-for="s in byStatus" :key="s.status">
                <td><span class="rp-badge" :class="statusBadge(s.status)">{{ statusLabel(s.status) }}</span></td>
                <td class="t-center rp-strong">{{ s.count }}</td>
                <td class="t-right rp-strong">{{ fmt(s.total) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title"><b-icon icon="list-ul"></b-icon> Zakaslar ro'yxati ({{ filtered.length }})</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>#</th><th>Sana</th><th>Mijoz</th><th>Tel</th><th>Manzil</th>
                <th class="t-right">Summa</th>
                <th class="t-center">Holat</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in filtered" :key="r.id">
                <td><span class="rp-num">#{{ r.id }}</span></td>
                <td class="rp-muted">{{ fmtDate(r.created_at) }}</td>
                <td class="rp-strong">{{ r.kontragent_name || '—' }}</td>
                <td class="rp-muted">{{ r.phone_number || '—' }}</td>
                <td class="rp-muted">{{ r.address || '—' }}</td>
                <td class="t-right rp-strong">{{ fmt(r.summa) }}</td>
                <td class="t-center">
                  <span class="rp-badge" :class="statusBadge(r.status)">{{ statusLabel(r.status) }}</span>
                </td>
              </tr>
              <tr v-if="!loading && filtered.length === 0"><td colspan="7" class="rp-empty">Zakas topilmadi</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
export default {
  data() {
    const today = new Date(); const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first), date2: this.ds(today),
      sklad_id: null, skladList: [], items: [], byStatus: [],
      totals: { count: 0, total_summa: 0 },
      statusFilter: '', loading: false,
    };
  },
  computed: {
    filtered() {
      if (!this.statusFilter) return this.items;
      return this.items.filter(r => r.status === this.statusFilter);
    },
    donutOptions() {
      return {
        chart: { fontFamily: 'inherit' },
        labels: this.byStatus.map(s => this.statusLabel(s.status)),
        colors: ['#2563eb', '#16a34a', '#94a3b8', '#e11d48'],
        legend: { position: 'bottom' },
        plotOptions: { pie: { donut: { size: '60%' } } },
      };
    },
    donutSeries() { return this.byStatus.map(s => s.count); }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    fmtDate(ts) { if (!ts) return '—'; const d = new Date(ts * 1000); return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }); },
    statusLabel(s) { return { 'new': 'Yangi', 'completed': 'Tugallangan', 'canceled': 'Bekor qilingan' }[s] || s || '—'; },
    statusBadge(s) { return { 'new': 'rp-badge-blue', 'completed': 'rp-badge-green', 'canceled': 'rp-badge-red' }[s] || 'rp-badge-warn'; },
    countBy(s) { const r = this.byStatus.find(x => x.status === s); return r ? r.count : 0; },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/orders/', {
          datetime1: this.toUnix(this.date1), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        this.items = r.data.items || [];
        this.byStatus = r.data.by_status || [];
        this.totals = r.data.totals || this.totals;
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    }
  }
};
</script>
